import React from 'react';
import { Flex } from '@atlaskit/primitives/compiled';
import type { UIAnalyticsEvent as AnalyticsEvent } from '@atlaskit/analytics-next';
import AvatarTitleCell from '@atlassian/jira-common-directory-v2/src/components/avatar-title-cell/view.tsx';
import type { Location as LocationType } from '@atlassian/jira-boards-common/src/model/index.tsx';
import Actions from '../actions/view.tsx';

type Props = {
	location: LocationType | undefined;
	isPrivate: boolean;
	isSimple: boolean;
	canEdit: boolean;
	defaultOpen: boolean;
} & {
	name: string | undefined;
	showSpinner: boolean;
	editBoardUrl: string;
	onEdit: (arg1: AnalyticsEvent) => void;
	onDelete: (
		event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
		arg1: AnalyticsEvent,
	) => void;
	onCopy: (
		event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
		arg1: AnalyticsEvent,
	) => void;
	onMove: (arg1: AnalyticsEvent) => void;
};

export default function LocationWithTypeActions(props: Props): React.JSX.Element | null {
	const { location } = props;

	if (location) {
		const appearance = location.type === 'user' ? 'circle' : 'square';

		return (
			<Flex alignItems="center">
				<AvatarTitleCell
					displayName={location.displayName}
					avatarUrl={location.avatarURI}
					appearance={appearance}
				/>
				<Actions {...props} />
			</Flex>
		);
	}
	return null;
}
